<template>
    <div :class="pieCountClass">
        <span class="rating-pie__number">
            {{ rating || 'N/A' }}
        </span>

        <svg viewBox="0 0 100 100">
            <defs>
                <linearGradient id="chart-fill" gradientTransform="rotate(45)">
                    <stop stop-color="#90CB5E" offset="15%" />
                    <stop stop-color="#50B2DB" offset="100%" />
                </linearGradient>
            </defs>
            <circle cx="50" cy="50" r="46" stroke-width="8" stroke="#ECF4F8" fill="none" />
            <circle
                ref="value"
                cx="50"
                cy="50"
                r="46"
                stroke-width="6"
                stroke-linecap="round"
                stroke="url(#chart-fill)"
                fill="none"
                transform="rotate(-90, 50, 50)"
            />
        </svg>
    </div>
</template>

<script>
    export default {
        props: {
            rating: { type: Number, default: undefined },
            type: { type: String, default: undefined },
            size: { type: String, default: 'large' },
        },

        computed: {
            percentage() {
                return this.rating ? (this.rating / 5) * 100 : 0
            },

            pieCountClass() {
                return {
                    'rating-pie': true,
                    [`rating-pie--size-${this.size}`]: this.size,
                }
            },
        },

        methods: {
            calculateChart(value) {
                const RADIUS = 46
                var CIRCUMFERENCE = 2 * Math.PI * RADIUS

                this.$refs.value.style.strokeDasharray = CIRCUMFERENCE
                this.$refs.value.style.strokeDashoffset = CIRCUMFERENCE * (1 - value / 100)
            },
        },

        mounted() {
            this.calculateChart(this.percentage)
        },
    }
</script>
